import { UpdateStamp } from './UpdateStamp';

export class PermitActionViewModel extends UpdateStamp
{
    SiteId: number;
    PermitTypeIds?:number[];
    CategoryId?: number;
    CategoryIds?: number[];
    isSiteSuspended?: boolean;
}